import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_URL} from '../constants';

export type CommunicationScope = 'ALL_USERS' | 'SPECIFIC_CHAPTERS' | 'MY_CHAPTER';

export interface ChapterCommunicationRequest {
    subject: string;
    body: string;
    scope: CommunicationScope;
    includeNonMembers: boolean;
    chapterIds?: string[];
}

export interface ChapterCommunicationResponse {
    deliveredCount: number;
    failedCount: number;
    recipients: string[];
    failedRecipients: string[];
}

export interface ChapterCommunicationHistoryItem {
    communicationId: string;
    chapterId: string;
    subject: string;
    body: string;
    scope: CommunicationScope;
    includeNonMembers: boolean;
    targetChapterIds: string[];
    deliveredCount: number;
    failedCount: number;
    sentByUserId: string;
    sentByRole: string;
    sentDate: string;
}

@Injectable({
    providedIn: 'root'
})
export class EmailApiService {
    private apiUrl = `${API_URL}` + 'email';

    constructor(private http: HttpClient) {
    }

    sendContactEmail(data: any): Observable<any> {
        return this.http.post(`${this.apiUrl}` + '/send-contact-email', data, {responseType: 'text'});
    }

    sendRegistrationEmail(data: any): Observable<any> {
        return this.http.post(`${this.apiUrl}` + '/send-registration-email', data, {responseType: 'text'});
    }

    sendChapterCommunication(data: ChapterCommunicationRequest): Observable<ChapterCommunicationResponse> {
        return this.http.post<ChapterCommunicationResponse>(`${this.apiUrl}/send-chapter-communication`, data);
    }

    getChapterCommunicationHistory(chapterId: string): Observable<ChapterCommunicationHistoryItem[]> {
        return this.http.get<ChapterCommunicationHistoryItem[]>(`${this.apiUrl}/chapter-communication-history/${chapterId}`);
    }
}
